// An agent's call in product words (APS-387, Mosaic): a call with no MCP tool is read from its
// route, `GET /v1/projects/<id>/releases`, as a verb and what it touched ("read releases",
// "read issue iss_8kq2"). Routes that do not read that way keep a short form ("GET …/releases").

export type CallVerb = 'read' | 'created' | 'changed' | 'deleted'

export type CallWords =
  | { kind: 'words'; verb: CallVerb; what: string }
  | { kind: 'route'; short: string }

const VERBS: Record<string, CallVerb> = {
  GET: 'read',
  POST: 'created',
  PATCH: 'changed',
  PUT: 'changed',
  DELETE: 'deleted',
}

/** An id in a path: a UUID, a prefixed id (iss_8kq2), a long hex id (a trace) or a number. */
const isId = (s: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s) ||
  /^[a-z]+_[A-Za-z0-9]+$/.test(s) ||
  /^[0-9a-f]{16,}$/i.test(s) ||
  /^\d+$/.test(s)

/** A collection's one item: issues → issue. */
const singular = (s: string) => (s.endsWith('s') && s.length > 3 ? s.slice(0, -1) : s)

export function callWords(route: string): CallWords {
  const [method = '', path = ''] = route.trim().split(/\s+/, 2)
  const parts = path.split('?')[0]?.split('/').filter(Boolean) ?? []
  // The API's version prefix, however many times it was recorded.
  while (parts[0] === 'v1') parts.shift()
  const last = parts.at(-1)
  const short = last ? `${method} …/${last}` : route
  const verb = VERBS[method.toUpperCase()]
  if (!verb || !last) return { kind: 'route', short }
  if (isId(last)) {
    const of = parts.at(-2)
    if (!of || isId(of) || !/^[a-z][a-z-]*$/.test(of)) return { kind: 'route', short }
    return { kind: 'words', verb, what: `${singular(of)} ${last}` }
  }
  if (!/^[a-z][a-z-]*$/.test(last)) return { kind: 'route', short }
  return { kind: 'words', verb, what: last }
}
